import React, { useState } from "react";
import {
  FaMapMarkerAlt,
  FaWallet,
  FaRocket,
  FaHeadset,
} from "react-icons/fa";
import { useScrollReveal } from "../../hooks/useScrollReveal";
import "./Accordion.css";

const steps = [
  {
    title: "Nous connaissons le marché ivoirien",
    content:
      "Basés à Abidjan, nous comprenons les réalités du marché local : les modes de paiement (Orange Money, Wave, MTN), les habitudes des utilisateurs et les besoins spécifiques des entreprises ivoiriennes. Vos clients sont les nôtres.",
    icon: <FaMapMarkerAlt className="accordion-step-icon" />,
  },
  {
    title: "Des prix accessibles, sans compromis sur la qualité",
    content:
      "Nous proposons des solutions digitales professionnelles à partir de 150 000 FCFA. Nos tarifs sont adaptés aux PME, startups et ONG qui veulent se digitaliser sans exploser leur budget.",
    icon: <FaWallet className="accordion-step-icon" />,
  },
  {
    title: "Livraison rapide et délais respectés",
    content:
      "Un site vitrine en 7 à 14 jours, une application en quelques semaines. Nous travaillons avec une méthodologie claire : maquette validée, développement par étapes, livraison dans les délais convenus.",
    icon: <FaRocket className="accordion-step-icon" />,
  },
  {
    title: "Accompagnement personnalisé à chaque étape",
    content:
      "Pas de jargon technique, pas de promesses vagues. Nous vous expliquons chaque décision, répondons à vos questions et restons disponibles après la livraison. Votre réussite digitale est notre priorité.",
    icon: <FaHeadset className="accordion-step-icon" />,
  },
];

const Accordion = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  useScrollReveal();

  const toggle = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div className="accordion-section">
      <h2 className="accordion-title" data-reveal="">Pourquoi nous choisir ?</h2>
      <div className="accordion">
        {steps.map((step, index) => (
          <div key={index} className="accordion-item" data-reveal="" data-delay={index * 80}>
            <div
              className={`accordion-header ${activeIndex === index ? "active" : ""}`}
              onClick={() => toggle(index)}
            >
              <div className="accordion-header-left">
                {step.icon}
                <h3>{step.title}</h3>
              </div>
              <span className="accordion-toggle">
                {activeIndex === index ? "−" : "+"}
              </span>
            </div>
            <div
              className={`accordion-content ${activeIndex === index ? "open" : ""}`}
            >
              <p>{step.content}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Accordion;
